import axios from 'axios';
var scrollTo = require('../functions/scroll-to');

if (document.querySelectorAll('.required-form')) {
  var $formWrapper = document.querySelectorAll('.required-form');
  var $stickerModalBg = document.querySelector('.sticker-modal-bg');
  var $stickerModal = document.querySelector('.sticker-success-modal');

  if (document.location.href.includes('thank-you')) {
    document.querySelector('.coto_form-wrapper').classList.add('submitted');
    setTimeout(function () {
      scrollTo(document.querySelector('.coto_form-wrapper'));
    }, 600);
  }

  for (let $wrapper of $formWrapper) {
    var $form = $wrapper.querySelector('.coto_form'),
      $required = $form.querySelectorAll('.required'),
      $phone = $form.querySelector('.phone');

    if ($phone) {
      $phone.addEventListener('keyup', function (event) {
        //numeric characters only
        if (
          !(event.keyCode > 47 && event.keyCode < 58) ||
          (event.keyCode < 106 && event.keyCode > 95)
        ) {
          this.value = this.value.replace(/[^\-0-9]/g, '');
        }
        //limit to 10 characters
        var max_chars = 10;

        if (this.value.length > max_chars) {
          this.value = this.value.substr(0, max_chars);
        }
      });
    }

    for (let $input of $required) {
      $input.addEventListener('change', function () {
        var $parent = this.parentNode;

        if (this.classList.contains('email')) {
          if (
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.value)
          ) {
            $parent.removeChild($parent.lastChild);
            $parent.classList.remove('error');
          } else {
            var invalidText = document.createElement('p');

            invalidText.className = 'error-message';
            invalidText.innerHTML = 'This is not a valid Email';

            $parent.classList.add('error');

            if ($parent.querySelector('.error-message')) {
              $parent.querySelector('.error-message').innerHTML =
                'This is not a valid Email';
            } else {
              $parent.appendChild(invalidText);
            }
          }
        } else {
          if (!this.value == '') {
            $parent.getElementsByTagName('P')[0];
            $parent.classList.remove('error');
          }
        }
      });
    }

    $form.addEventListener('submit', function (event) {
      event.preventDefault();

      for (let $input of $required) {
        var $parent = $input.parentNode,
          value = $input.value,
          requiredText = document.createElement('p');

        requiredText.className = 'error-message';
        requiredText.innerHTML = 'This is a required field';

        if (value == '') {
          $input.parentNode.classList.add('error');

          if ($parent.querySelector('.error-message')) {
            $parent.querySelector('.error-message').innerHTML =
              'This is a required field';
          } else {
            $parent.appendChild(requiredText);
          }
        }
      }

      if ($form.querySelectorAll('.error').length == 0) {
        // Sailtru form
        if ($wrapper.classList.contains('sailthru-form')) {
          let email = $form.querySelector('.email').value;
          let data = {
            listID: 'KSwZU4',
            email: email,
            isEU: window.location.href.includes('eu.cotopaxi.com')
              ? true
              : false,
            name:
              $form.querySelector('.first-name').value +
              $form.querySelector('.last-name').value,
            phone: $form.querySelector('.phone').value,
            event: $form.querySelector('.event').value,
          };
          axios
            .post(
              'https://production-access-api.cotopaxi.com/klaviyo/addEmailToKlaviyoList',
              data
            )
            .then((response) => {
              //console.log('succesfully added to email list');
              $wrapper.classList.add('submitted');
            })
            .catch((error) => $wrapper.classList.add('form-error'));
          // Foundation Form
          // } else if ($wrapper.classList.contains('coto_foundation-form')) {
          //   axios
          //     .post(
          //       'https://livewireapi-public.cotopaxi.com/form/cotopaxiFoundation',
          //       {
          //         Field2: $form.querySelector('.first-name').value,
          //         Field1: $form.querySelector('.last-name').value,
          //         Field5: $form.querySelector('.company').value,
          //         Field4: $form.querySelector('.email').value,
          //         Field3: $form.querySelector('.phone').value,
          //       }
          //     )
          //     .then(() => $wrapper.classList.add('submitted'));
          // Group Form
          // } else if ($wrapper.classList.contains('coto_group-form')) {
          //   let jsonbody = {
          //     firstName: $form.querySelector('.first-name').value,
          //     lastName: $form.querySelector('.last-name').value,
          //     company: $form.querySelector('.company').value,
          //     email: $form.querySelector('.email').value,
          //     phone: $form.querySelector('.phone').value,
          //     address: $form.querySelector('.address').value,
          //     city: $form.querySelector('.city').value,
          //     state: $form.querySelector('.state').value,
          //     zip: $form.querySelector('.zip').value,
          //     comments: $form.querySelector('.comments').value,
          //     industry: $form.querySelector('.industry').value,
          //     groupSize: $form.querySelector('.group-size').value,
          //     products: $form.querySelector('.products').value,
          //     cobranding: $form.querySelector('.cobranding').value,
          //     asiPpsi: $form.querySelector('.asi-ppsi').value,
          //     thirdParty: $form.querySelector('.third-party').value,
          //   };
          //   //send to netsuite
          //   axios
          //     .post(
          //       'https://livewireapi-public.cotopaxi.com/form/cotopaxiGroupSales',
          //       jsonbody
          //     )
          //     .then(() => {
          //       //... then send to Klayvio
          //       //group sale form only lives on US, so only 1 list ID
          //       jsonbody.listID = 'JaYsQx';
          //       jsonbody.isEU = false;
          //       jsonbody.name = jsonbody.fistName + ' ' + jsonbody.lastName;

          //       axios
          //         .post(
          //           'https://livewireapi-public.cotopaxi.com/klaviyo/addEmailToKlaviyoList',
          //           jsonbody
          //         )
          //         .then((response) => {
          //           $wrapper.classList.add('submitted');
          //         });
          //     });
          // Questival Form
        } else if ($wrapper.classList.contains('coto_questival-form')) {
          let email = $form.querySelector('.email').value;
          let data = {
            listID: 'LT3k83',
            email: email,
            isEU: window.location.href.includes('eu.cotopaxi.com')
              ? true
              : false,
          };
          axios
            .post(
              'https://production-access-api.cotopaxi.com/klaviyo/addEmailToKlaviyoList',
              data
            )
            .then((response) => {
              //console.log('succesfully added to email list');
              $wrapper.classList.add('submitted');
            })
            .catch((error) => $wrapper.classList.add('form-error'));
          // One Utah
        } else if ($wrapper.classList.contains('coto_oneutah-form')) {
          let email = $form.querySelector('.email').value;
          let data = {
            listID: 'JMz2sn',
            email: email,
            isEU: window.location.href.includes('eu.cotopaxi.com')
              ? true
              : false,
          };
          axios
            .post(
              'https://production-access-api.cotopaxi.com/klaviyo/addEmailToKlaviyoList',
              data
            )
            .then((response) => {
              //console.log('succesfully added to email list');
              $wrapper.classList.add('submitted');
            })
            .catch((error) => $wrapper.classList.add('form-error'));

          // everything else form (free sticker form. Can't be everything else if dumac is involved?)
        } else {
          let email = $form.querySelector('.email').value;
          let data = {
            listID: 'S7P9fC',
            email: email,
            isEU: false,
            name: $form.querySelector('.name').value,
            address: $form.querySelector('.street-address').value,
            city: $form.querySelector('.city').value,
            state: $form.querySelector('.state').value,
            zip: $form.querySelector('.zip-code').value,
            //bday: $form.querySelector('.bday').value,
            //phone: $form.querySelector('.phone').value,
          };
          axios
            .post(
              'https://production-access-api.cotopaxi.com/klaviyo/addEmailToKlaviyoList',
              data
            )
            .then((response) => {
              //console.log('succesfully added to email list');
            })
            .catch((error) => $wrapper.classList.add('form-error'));

          axios
            .post(
              'https://production-access-api.cotopaxi.com/dumac/freeStickerRequest',
              {
                name: $form.querySelector('.name').value,
                address: $form.querySelector('.street-address').value,
                city: $form.querySelector('.city').value,
                state: $form.querySelector('.state').value,
                zip: $form.querySelector('.zip-code').value,
                email: $form.querySelector('.email').value,
              }
            )
            .then(() => {
              $wrapper.classList.add('submitted');
              $stickerModalBg.classList.remove('hide');
              $stickerModal.classList.remove('hide');
              setTimeout(function () {
                $stickerModal.classList.add('show');
              }, 150);
            })
            .catch((error) => $wrapper.classList.add('form-error'));

          //Dynamic Yield Sign up event
          let dynamicYieldEmail = DYO.dyhash.sha256(email.toLowerCase());

          //adding a newsletter specific send for DY - this should be used in conjunction with the sign up event above.
          DY.API('event', {
            name: 'Newsletter Subscription',
            properties: {
              dyType: 'newsletter-subscription-v1',
              hashedEmail: dynamicYieldEmail, // SHA256 encoding of the lowercase email.
              //phoneNumber:"+972503803434"
            },
          });
          //end Dynamic Yield signup event
        }
      }
    });
  }
}

$(document).ready(function () {
  if ($('.coto_sticker-please-form').length) {
    let step1Height = $('.form-step-one').outerHeight();
    let step2Height = $('.form-step-two').outerHeight();
    // $('.steps').css({
    //   height: step1Height,
    // });
    $('.next-step').on('click', function (e) {
      e.preventDefault();
      $('.coto_sticker-please-form').addClass('step-2');
      //   $('.steps').css({
      //     height: step2Height,
      //   });
    });
    $('.go-back').on('click', function (e) {
      e.preventDefault();
      $('.coto_sticker-please-form').removeClass('step-2');
      //   $('.steps').css({
      //     height: step1Height,
      //   });
    });
    $('.sticker-success-modal .close, .sticker-modal-bg').on(
      'click',
      function () {
        $('.sticker-modal-bg').removeClass('show');
        $('.sticker-success-modal, .sticker-modal-bg').addClass('hide');
      }
    );
  }
});
